// extracted by mini-css-extract-plugin
export default {"card":"CompanyInfo_card__GhYys","title":"CompanyInfo_title__qXvEn","info":"CompanyInfo_info__T+nuH"};